var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import Delta from 'quill-delta';
import { MediaAsset } from 'packages/media/MediaAsset';
import { Job } from 'packages/jobs/entities/Job';
import { AppearanceSettings } from 'packages/job_lists/AppearanceSettings';
import { JobList } from 'packages/job_lists/JobList';
import ENV from 'config/env';
var LandingPage = /** @class */ (function (_super) {
    __extends(LandingPage, _super);
    function LandingPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.companyId = null;
        _this.job = null;
        _this.jobId = null;
        _this.slug = null;
        _this.name = null;
        _this.heroImage = null;
        _this.logo = null;
        _this.publishedAt = null;
        _this.isPublished = true;
        _this.content = null;
        _this.locale = null;
        _this.stringIdentifier = null;
        _this.appearance = null;
        _this.jobLists = [];
        return _this;
    }
    Object.defineProperty(LandingPage.prototype, "urlPath", {
        get: function () {
            return this.stringIdentifier + "-" + this.slug;
        },
        enumerable: false,
        configurable: true
    });
    LandingPage.prototype.generateLink = function (accessToken) {
        if (this.jobLists[0]) {
            return this.jobLists[0].url + "/" + this.stringIdentifier + "-" + this.slug;
        }
        return this.generatePublicLink(accessToken);
    };
    LandingPage.prototype.generatePublicLink = function (accessToken) {
        if (accessToken) {
            return ENV.APPS.PUBLIC.URL + "landing-pages/" + this.stringIdentifier + "-" + this.slug + "?accessToken=" + accessToken;
        }
        return ENV.APPS.PUBLIC.URL + "landing-pages/" + this.stringIdentifier + "-" + this.slug;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    LandingPage.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        if (jsonData.content) {
            this.content = new Delta(jsonData.content);
        }
        if (typeof jsonData.published_at !== 'undefined') {
            this.isPublished = this.publishedAt !== null;
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    LandingPage.prototype.toJson = function () {
        var json = _super.prototype.toJson.call(this);
        json.content = this.content;
        return json;
    };
    LandingPage.prototype.toSaveRequest = function () {
        var requestJson = this.toJson();
        if (requestJson.appearance.logo) {
            requestJson.logo_id = requestJson.appearance.logo.id;
        }
        if (requestJson.appearance.hero_image) {
            requestJson.hero_image_id = requestJson.appearance.hero_image.id;
        }
        delete requestJson.is_published;
        delete requestJson.appearance;
        delete requestJson.hero_image;
        delete requestJson.logo;
        return requestJson;
    };
    LandingPage.prototype.replaceButtonFormLink = function (formUuid) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.content.ops.find(function (op) { var _a, _b; return ((_b = (_a = op.insert) === null || _a === void 0 ? void 0 : _a.FormLinkEmbed) === null || _b === void 0 ? void 0 : _b.formUuid) !== undefined; }).insert.FormLinkEmbed.formUuid = formUuid;
    };
    var _a, _b, _c, _d, _e;
    __decorate([
        Type(Job),
        __metadata("design:type", typeof (_a = typeof Job !== "undefined" && Job) === "function" ? _a : Object)
    ], LandingPage.prototype, "job", void 0);
    __decorate([
        Type(MediaAsset),
        __metadata("design:type", typeof (_b = typeof MediaAsset !== "undefined" && MediaAsset) === "function" ? _b : Object)
    ], LandingPage.prototype, "heroImage", void 0);
    __decorate([
        Type(MediaAsset),
        __metadata("design:type", typeof (_c = typeof MediaAsset !== "undefined" && MediaAsset) === "function" ? _c : Object)
    ], LandingPage.prototype, "logo", void 0);
    __decorate([
        Type(Object),
        __metadata("design:type", typeof (_d = typeof Delta !== "undefined" && Delta) === "function" ? _d : Object)
    ], LandingPage.prototype, "content", void 0);
    __decorate([
        Type(AppearanceSettings),
        __metadata("design:type", typeof (_e = typeof AppearanceSettings !== "undefined" && AppearanceSettings) === "function" ? _e : Object)
    ], LandingPage.prototype, "appearance", void 0);
    __decorate([
        Type(JobList),
        __metadata("design:type", Array)
    ], LandingPage.prototype, "jobLists", void 0);
    return LandingPage;
}(Entity));
export { LandingPage };
